import '../styles/ModalCambios.css';

export default function ModalCambios({ onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal-cambios">
        <h3>¡¡Novedades de la versión!!</h3>

        <ul className="lista-cambios">
          <li>HISTORIAL PRESUPUESTOS:
            <ul>
              <li className="lista-cambios 2" >En el historial econonómico de cada paciente, en los botones a pie de página</li>
              <li className="lista-cambios 2">Se pueden consultar los presupuestos creados a partir de hoy y descargar</li>
              <li className="lista-cambios 2">Cuando se imprime un presupuesto, automaticamente se guarda en su historial</li>
            </ul>
          </li>    
          <li>HISTORIAL FACTURAS:
            <ul>
              <li className="lista-cambios 2" >En el historial econonómico de cada paciente, en los botones a pie de página</li>
              <li className="lista-cambios 2">Se pueden consultar las facturas creadas a partir de hoy y descargar</li>
              <li className="lista-cambios 2">Si existieran facturas antiguas, solo apareceran los datos básicos</li>
              <li className="lista-cambios 2">Cuando se imprime una factura, automaticamente se guarda en su historial</li>
            </ul>
          </li>   
        </ul>

        <h4>Recordatorios</h4>
        <ul className="lista-recordatorios">
          <li>Cualquier duda, error o sugerencia contactar con Raúl.</li>
        </ul>

        <div className="modal-acciones">
          <button onClick={onClose}>Entendido</button>
        </div>
      </div>
    </div>
  );
}
